import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import './MarqueeStyles.css';
import CreateProfileModal from './CreateProfileModal';
import { useDispatch, useSelector } from 'react-redux';
import { readSchools } from '../../../store/actions/schoolActions';
import UpdateProfileModal from './UpdateProfileModal';

const SchoolProfile = () => {

  const dispatch = useDispatch();
  const { schools, loading, error } = useSelector((state) => state.schoolDetails);
// const [schools, setSchools] = useState(null);

  useEffect(() => {
    dispatch(readSchools()); 
  }, [dispatch]);


  const placeholderImage = 'https://cdn-icons-png.flaticon.com/512/847/847969.png';

  // Sample data for persons
  const persons = [
    { name: 'Nmae', designation: 'Principal', image: '' },
    { name: 'Name', designation: 'Vice Principal', image: '' }, // No image available
    { name: 'Name', designation: 'Head Teacher', image: '' }
  ];

  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  
  const [updateModal, setUpdateModal] = useState(false);

  // Simulate school ID or fetch it from API
  const [idForUpdate, setIdForUpdate ]=useState(null);

  const handleUpdateClick = (school_id) => {
    const oneData = schools.find(school => school.school_id === school_id);
    setIdForUpdate(oneData); // Set the data for the selected school
    setUpdateModal(true);    // Show the modal
  };
  

  const handleUpdateClose = () => {
    setUpdateModal(false);
  };

  return (
    <>
    <div className="col-xl-12">
        <div className="page-title flex-wrap">
            <div className="input-group search-area mb-md-0 mb-3">
            </div>
            <div className='d-flex'>
                <button className='btn btn-success' onClick={handleShow} disabled={schools && schools.length > 0}>Create School Profile</button>
            </div>
        </div>
    </div>
    <Container className="mt-5">
      <Row className="justify-content-start">
        {/* Left Column: 3 Images */}
        <Col md={2} className="d-flex flex-column align-items-end">
            {schools && schools.length > 0 ? (
            schools.map((school, index) => (
                <div key={index} className="text-center mb-4">
                <Image 
                    src={school.principal_image ? `data:image/jpeg;base64, ${school.principal_image}` : placeholderImage} 
                    thumbnail 
                    className="mb-2" 
                />
                <h5>{school.principal_name || "Principal"}</h5>
                <p className='text-dark'>Principal</p>
                
                <Image 
                    src={school.director_image ? `data:image/jpeg;base64, ${school.director_image}` : placeholderImage} 
                    thumbnail 
                    className="mb-2" 
                />
                <h5>{school.director_name || "Director"}</h5>
                <p className='text-dark'>Director</p>

                <Image 
                    src={school.head_teacher_image ? `data:image/jpeg;base64, ${school.head_teacher_image}` : placeholderImage} 
                    thumbnail 
                    className="mb-2" 
                />
                <h5>{school.head_teacher_name || "Head Teacher"}</h5>
                <p className='text-dark'>Head Teacher</p>
                </div>
            ))
            ) : (
            <div className="text-center mb-4">
                {persons.map((person, index) => (
                    <div key={index} className="text-center mb-4">
                    <Image src={person.image || placeholderImage} thumbnail className="mb-2" />
                    <h5>{person.name}</h5>
                    <p className='text-dark'>{person.designation}</p>
                    </div>
                ))}
            </div>
            )}

        </Col>

        {/* Vertical Line */}
        <Col md={1} className="d-flex justify-content-start">
          <div style={{ borderLeft: '1px solid #000', height: '100%' }}></div>
        </Col>

        {/* Right Column: School Details with Edit Button */}
        <Col md={4}>

            {!schools || schools.length === 0 ? (
                <>
                    <h3 className="mb-4">School Details</h3>
                    <p style={{fontSize:'16px'}}>School Name:</p>
                    <p style={{fontSize:'16px'}}>Address:</p>
                    <p style={{fontSize:'16px'}}>City:</p>
                    <p style={{fontSize:'16px'}}>Contact Number:</p>
                    <p style={{fontSize:'16px'}}>Email:</p>
                    <p style={{fontSize:'16px'}}>Website:</p>
                </>
            ) : (
            schools.map((school, index) => (
                <div key={index}>
                    <h3 className="mb-4">School Details</h3>
                    <p style={{fontSize:'16px'}}><strong>School Name:</strong> {school.school_name}</p>
                    <p style={{fontSize:'16px'}}><strong>Address:</strong> {school.school_address}</p>
                    <p style={{fontSize:'16px'}}><strong>City:</strong> {school.city}</p>
                    <p style={{fontSize:'16px'}}><strong>Contact Number:</strong> {school.contact_number}</p>
                    <p style={{fontSize:'16px'}}><strong>Email:</strong> {school.email_address}</p>
                    <p style={{fontSize:'16px'}}><strong>Website:</strong> {school.website_url}</p>
                    <Button variant="primary" className="mt-3" onClick={()=>handleUpdateClick(school.school_id)}>Edit Details</Button>
                </div>
             ))
            )}

          {/* Edit Button */}
        </Col>

        {/* New Column for Vertical Marquee */}
       <Col md={5}>
            <div className="p-3 bg-white rounded shadow-sm" style={{ height: '88%', overflow: 'hidden' }}>
              <h3 className="mb-4 full-width-underline"><strong style={{color:"black"}}>Announcements</strong></h3>
              <div className="marquee">
                <div className="marquee-content">
                  <p className='text-dark'><span className="blink-star">🚨</span>Upcoming School Event on October 10th</p>
                  <p className='text-dark'>Annual Sports Day Registration Open!</p>
                  <p className='text-dark'>Parent-Teacher Meeting on October 20th</p>
                  <p className='text-dark'>New Admissions Open for 2025-2026</p>
                  <p className='text-dark'>Winter Uniform Sale Starts November 1st</p>
                  <p className='text-dark'><span className="blink-star">🚨</span>Upcoming School Event on October 10th</p>
                  <p className='text-dark'>Annual Sports Day Registration Open!</p>
                  <p className='text-dark'>Parent-Teacher Meeting on October 20th</p>
                  <p className='text-dark'>New Admissions Open for 2025-2026</p>
                  <p className='text-dark'>Winter Uniform Sale Starts November 1st</p>
                  
                </div>
              </div>
            </div>
          </Col>
      </Row>
    </Container>

    {/* Create profile Modal */}
    <CreateProfileModal showModal={showModal} handleClose={handleClose} />

    {/* UpdateProfileModal  */}
    <UpdateProfileModal updateModal={updateModal} handleUpdateClose={handleUpdateClose} school_id={idForUpdate}/>
    </>
  );
};



export default SchoolProfile
